import React, { Component } from "react";
import { getRequest, postRequest } from "../api/ApiService";
import EventEmitter from "./event-emitter";

class AnalyticsSend extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.event = null;
    this.eventEmitter = EventEmitter.getInstance();
    this.oneTimeTrackPages = [
      '/analysis/team-reports',
      '/analysis/bcase',
      '/ceo/analysis/market',
      '/pd/analysis/market',
      '/pm/analysis/market',
      '/op/analysis/market',
      '/fn/analysis/market',
    ];
  }

  render() {
    return <div />;
  }

  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  setTimer = () => {
    this.timer = setTimeout(this.sendEvent, 5000); // 5 seconds
  }

  componentDidMount() {
    this.eventEmitter.on("analytics-event", this.setEvent);
  }

  componentWillUnmount() {
    this.clearTimer();
    this.event = null;
    this.eventEmitter.off("analytics-event", this.setEvent);
  }

  setEvent = (round_number, url, user_id, game_id, course_id, pathname) => {
    if (this.event) {
      this.clearTimer();
      this.event = null;
    }

    this.event = {
      round_number,
      url,
      user_id,
      game_id,
      course_id,
      pathname,
    };
    this.setTimer();
  }

  sendEvent = () => {
    if (this.event) {
      let oneTimeTrackPage = false;
      for (const pattern of this.oneTimeTrackPages) {
        if (this.event.pathname.startsWith(pattern) === true) {
          oneTimeTrackPage = true;
        }
      }

      if (oneTimeTrackPage === true) {
        const gameId = Number(this.event.game_id);
        const courseId = Number(this.event.course_id);
        const userId = Number(this.event.user_id);
        const roundNumber = Number(this.event.round_number);
        getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}&round_number=${roundNumber}`)
          .then((data) => {
            const pages = data.body.results;
            const url = this.event.url.split('?')[0];
            const isTracked = pages.find(i => (
              i.page === url
            ));

            if (!isTracked) {
              postRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/`)
                .send({
                  page: url,
                  user: this.event.user_id,
                  course: this.event.course_id,
                  game: this.event.game_id,
                  round_number: this.event.round_number,
                })
                .then((data) => {
                  this.event = null;
                  // do nothing
                });
            } else {
              this.event = null;
            }
          });
      } else {
        const url = this.event.url.split('?')[0];
        postRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/`)
          .send({
            page: url,
            user: this.event.user_id,
            course: this.event.course_id,
            game: this.event.game_id,
            round_number: this.event.round_number,
          })
          .then((data) => {
            this.event = null;
            // do nothing
          });
      }
    }
  }
}

export default AnalyticsSend;



// WEBPACK FOOTER //
// ./src/services/analytics-send.js